class NameFormat {
    constructor() {
        this.firstLastName = document.getElementById("add_file_mapping_nameFormat_0");
        this.fullName = document.getElementById("add_file_mapping_nameFormat_1");

        if (!this.firstLastName || !this.fullName) {
            return;
        }

        this.firstLastNameBlock = document.getElementById("js-first-last-format");
        this.fullNameBlock = document.getElementById("js-full-format");

        this.bind();
    }

    changeNameFormat() {
        if (this.firstLastName.checked) {
            this.firstLastNameBlock.classList.remove("d-n");
            this.fullNameBlock.classList.add("d-n");

        } else if (this.fullName.checked) {
            this.fullNameBlock.classList.remove("d-n");
            this.firstLastNameBlock.classList.add("d-n");
        }
    }

    bind() {
        this.firstLastName.addEventListener("change", this.changeNameFormat.bind(this));
        this.fullName.addEventListener("change", this.changeNameFormat.bind(this));
    }
}

export default NameFormat;
